import { ANY_RESOURCE_ID, ANY_INTERNAL_RESOURCE_ID, ANY_EXTERNAL_RESOURCE_ID } from '../../constants'

const ANY_RESOURCE_IDS = new Set([ANY_RESOURCE_ID, ANY_INTERNAL_RESOURCE_ID, ANY_EXTERNAL_RESOURCE_ID])

const isAnyResourceId = (resourceId: string | undefined | null) => resourceId != null && ANY_RESOURCE_IDS.has(resourceId)

export { isAnyResourceId }
